export class AttachmentResponse {
	attachmentId: string;
	fileName: string;
	size: string;
	uploadedDate: string;
	Button: any;     // used to display button in the grid
	fileServiceId: string;
}
